/* eslint-disable max-len */
// /* eslint-disable max-len */
import {React,useContext, useState} from 'react'
import AnimatedListPatient from '../../../../components/Animation/AnimatedListPatient'
import AnimatedButton from '../../../../components/Animation/AnimatedButton'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { toggleRowSelection } from '../../../../redux/MultiselectRowsConditionally'
import moment from 'moment'
import formatMobileNumber from '../../../../CommonMethods/FormatMobileNumber'
import { convertEpochToDateFormat } from '../../../../CommonMethods/convertEpochToDateFormat'
import { handleEditMessageSent } from '../../../../redux/systemConfigSlice'
import GlobalContext from '../../../../components/Context/GloablContext'
import { organizationusersList } from '../../../../slices/apiSlice'
import ConfirmationPrompt from '../../../../components/ConfirmationPrompt'
import AnimatedModel from '../../../../components/Animation/AnimatedModel'

const TableBody = ({ tableData,
    List,
    indexNum,
    pageNumber,
    selectedIndex,
    setSelectedIndex,
    selectedRef,
    lastIndex,
    setConfirmationState,
    setTextAreaMsg,
    handleDelete,
    loading,
}) => {
    const navigate = useNavigate()
    const auth = useSelector(state => state.auth)
    const { userType } = auth
    const dispatch = useDispatch()
    const dateformat = useSelector(state => state.systemConfigData.globalVariables.date_format)
    const [searchParams, setSearchParams] = useSearchParams({})
    const selectedRows = useSelector(state => state.MultiSelectSliceConditionally.selectedRows.selectedIds)
    const messageSent = useSelector(state=>state?.systemConfigData?.messageSent)
    const {sendMessageToStartEditing,receiveMessageFromSocket,editSocket,setToastErrorMessage} = useContext(GlobalContext)
    const [isDeleteOpen, setIsDeleteOpen] = useState(false)

    const handelActionButton = async (indexNum) => {
        setSelectedIndex(indexNum)

    }

    const handleDeleteItem = () => {
        handleDelete(tableData?.user_name)
    }

    const handleCheckboxChange = () => {

        dispatch(toggleRowSelection([tableData?.user_id, pageNumber.toString(), List.data, tableData?.user_name, tableData?.status]))

    };

    const onClickActivation = (e) => {
        e.preventDefault();
        setTextAreaMsg('');
        setSelectedIndex(null);
        setConfirmationState((prev) => ({
            ...prev,
            isOpen: true,
            rowData: tableData,
            multirow: ''
        }))

    }

    const date = convertEpochToDateFormat(tableData?.created_at, dateformat)
    return (
        <>
            <AnimatedListPatient
                id={tableData?.user_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                cursorpointer
                handleClick={(e) => {
                    if (e.target.classList.contains('prevent-click')) {
                        return;
                    } else {
                        navigate(`/manage-observer/${tableData?._id}`, { state: Array.isArray(location.state) ? '' : Object.fromEntries(searchParams) })
                    }
                }}
                child={
                    <>
                        <td data-testid={`observer-check-${indexNum}`} className="px-[18px] py-2 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px] prevent-click">
                            <div className="relative checkbox custom-checkBoxBlue1">

                                <input type="checkbox" id={tableData?.user_id} checked={selectedRows?.some((obj) => obj?.id === tableData?.user_id) ? true : false} onChange={() => handleCheckboxChange()} className='cursor-pointer prevent-click' />
                                <label htmlFor={tableData?.user_id} className="text-sm font-normal text-[#031624] w-full cursor-pointer prevent-click"></label>
                            </div>
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal  text-[#031624]">{tableData?.user_id}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal break-all text-[#031624]">{tableData?.user_name}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal break-all text-[#031624]">{tableData?.first_name}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal  break-all text-[#031624]">{tableData?.last_name === "" ? "-" : tableData?.last_name}</td>
                        <td className="px-[18px] py-2">
                            <div className="flex items-center justify-start">
                                <img loading="lazy" decoding="async" src={`${tableData?.status === "active" ? "/images/active_list_img.svg" : '/images/inactive_list_img.svg'}`} alt="icon" />
                                <span className="text-sm text-start font-normal text-[#031624] pl-2">{tableData?.status === "active" ? "Active" : "Inactive"}</span>
                            </div>
                        </td>
                        {/* SMS Alert */}
                        <td id={`SMS_Alert${indexNum}`} className="px-[18px] py-2 text-sm text-start font-normal">
                            <span className={`inline-flex items-center justify-center ${tableData?.sms_alert === true ? 'bg-[#C0ECCE] text-[#1A883C]' : 'bg-[#E7EAF4] text-[#000000]'} px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                                {tableData?.sms_alert === true ? "ON" : "OFF"}
                            </span>
                        </td>
                        {/* Email Alert */}
                        <td id={`Email_Alert${indexNum}`} className="px-[18px] py-2 text-sm text-start font-normal">
                            <span className={`inline-flex items-center justify-center ${tableData?.email_alert === true ? 'bg-[#C0ECCE] text-[#1A883C]' : 'bg-[#E7EAF4] text-[#000000]'} px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                                {tableData?.email_alert === true ? "ON" : "OFF"}
                            </span>
                        </td>
                        {/* Missed Reading Alert */}
                        <td id={`Missed_Reading${indexNum}`} className="px-[18px] py-2 text-sm text-start font-normal">
                            <span className={`inline-flex items-center justify-center ${tableData?.missed_reading_alert === true ? 'bg-[#C0ECCE] text-[#1A883C]' : 'bg-[#E7EAF4] text-[#000000]'} px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                                {tableData?.missed_reading_alert === true ? "ON" : "OFF"}
                            </span>
                        </td>
                        {/* Reading Received Alert */}
                        <td id={`Reading_Received${indexNum}`} className="px-[18px] py-2 text-sm text-start font-normal">
                            <span className={`inline-flex items-center justify-center ${tableData?.reading_received_alert === true ? 'bg-[#C0ECCE] text-[#1A883C]' : 'bg-[#E7EAF4] text-[#000000]'} px-[10px] py-[4px] rounded-[28px] w-[60px] h-[19px]`}>
                                {tableData?.reading_received_alert === true ? "ON" : "OFF"}
                            </span>
                        </td>
                        <td className="px-[18px] py-2 text-sm break-all text-start font-normal text-[#031624]">
                            {tableData?.patient_first_name === "" || tableData?.patient_first_name === undefined
                                ? "-"
                                : tableData?.patient_middle_name
                                    ? `${tableData?.patient_last_name}, ${tableData?.patient_first_name} ${tableData?.patient_middle_name}`
                                    : `${tableData?.patient_last_name}, ${tableData?.patient_first_name}`}
                        </td>
                        {/* <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.patient_first_name===""||tableData?.patient_first_name===undefined?"-":`${tableData?.patient_last_name},${tableData?.patient_first_name} ${tableData?.patient_middle_name}`}</td> */}
                        <td className="px-[18px] py-2 text-sm text-start font-normal break-all text-[#031624]">{tableData?.subdivision_name === "" || tableData?.subdivision_name === undefined ? "-" : tableData?.subdivision_name}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal break-all text-[#031624]">{tableData?.email_address === "" ? "-" : tableData?.email_address}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData.mobile_number !== "" ? tableData?.mobile_country_code + " " + (formatMobileNumber(tableData?.mobile_number)) : '-'}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.main_country_code + " " + formatMobileNumber(tableData?.main_number)}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{date}</td>
                        <td className={`px-[18px] py-2 text-sm text-start font-normal text-[#031624] rounded-tr-[2px] rounded-br-[2px] sticky right-[-1px] prevent-click ${selectedRows.map((item) => item.id).includes(tableData?.user_id) ? 'bg-[#F8EEF1]' : 'bg-white '} last-td`}>
                            <div className="relative flex items-center justify-center" data-te-dropdown-ref>
                                <button type='button' className="text-white transition duration-150 ease-in-out w-[40px] h-[34px] rounded-[50%] flex justify-center items-center prevent-click"
                                    id={"id"}
                                    // disabled={(userCognitoEmail === tableData.email_address) ? true : false}
                                    onClick={() => handelActionButton(indexNum)}
                                    data-te-dropdown-toggle-ref
                                    aria-expanded="false"
                                    data-te-ripple-init
                                    data-testid="list-users"
                                    // disabled={() => handelActionButton()}
                                    data-te-ripple-color="light">
                                    <img id="3-dot" loading="lazy" decoding="async" src="/images/3_dots_list.svg" alt="icon" className="prevent-click" />
                                </button>
                                {selectedIndex === indexNum && <ul ref={selectedRef} className={`border border-[#C2DCEF] p-2.5 absolute z-[99] float-left m-0 ${lastIndex === indexNum + 1 ? ' top-[0px]' : 'top-0'} right-[75px] min-w-[135px] list-none rounded-lg  bg-white bg-clip-padding text-left [&[data-te-dropdown-show]]:block prevent-click`} aria-labelledby="dropdownMenuButton2" data-te-dropdown-menu-ref >


                                    <li>
                                        <AnimatedButton
                                            handleClick={(e) => { }}
                                            buttonName={"View"}
                                            locnState={Object.fromEntries(searchParams)}
                                            link={`/manage-observer/${tableData._id}`}
                                            className="block w-full text-start whitespace-nowrap bg-transparent hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px] rounded py-1 mb-2.5 text-base font-normal text-[#000000] prevent-click" />
                                    </li>
                            
                                    <li>
                                        <AnimatedButton
                                            handleClick={() => {
                                                if(!messageSent){
                                                    sendMessageToStartEditing(tableData?.user_id)
                                                    let message
                                                    editSocket.onmessage = (event) =>{
                                                        message = event.data
                                                        if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                                                            dispatch(organizationusersList.util.resetApiState())                
                                                            navigate(`/manage-observer/edit-observer/${tableData._id}`,{state:Object.fromEntries(searchParams)})
                                                        } else{
                                                            dispatch(handleEditMessageSent(false))
                                                            { (JSON.parse(message)?.adminId) &&
                                                                setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this observer`)
                                                            }
                                                        }
                                                    }    
                                                }
                                            
                                            }
                                            }
                                            
                                            buttonName={"Edit"}
                                            locnState={Object.fromEntries(searchParams)}
                                            // link={`/manage-observer/edit-observer/${tableData._id}`}
                                            className="block w-full text-start whitespace-nowrap bg-transparent hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px] rounded py-1 mb-2.5 text-base font-normal text-[#000000] prevent-click" />
                                    </li>
                                    <li>
                                        <AnimatedButton
                                            handleClick={(e) => { onClickActivation(e) }}
                                            buttonName={`${tableData?.status === "active" ? 'Deactivate' : 'Activate'}`}
                                            className="block w-full text-start whitespace-nowrap bg-transparent  hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px] rounded py-1 mb-2.5 text-base font-normal text-[#000000] prevent-click" />
                                    </li>
                                    <li>
                                        <AnimatedButton
                                            buttonName={"Delete"}
                                            handleClick={() => { setIsDeleteOpen(true) }}
                                            className="block w-full text-start whitespace-nowrap bg-transparent hover:text-[#008586] hover:bg-[#F4F7FC] px-[2px] rounded py-1 text-base font-normal text-[#000000] prevent-click" />
                                    </li>
                                    <div className='absolute top-[12px] right-[-9px] rotate-[45deg] w-4 h-4 border-t border-r border-[#C2DCEF] bg-[#fff] z-0'>

                                    </div>

                                </ul>}

                            </div>
                        </td>
                    </>

                } />
            {isDeleteOpen &&
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleDeleteItem}
                        handleClose={() => setIsDeleteOpen(false)}
                        tittle= {'Delete'}
                        message = {`Are you sure you want to delete this observer?`}
                        buttonName = {"Yes"}
                        loadingActivation={loading}
                        CancelButton = {"No"}
                    />
                }
            />
            }
        </>
    )
}

export default TableBody